<template>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :timeout="timeout"
  >
    <div class="notification-content">
      <div class="notification-body">
        <span class="text-h6 notification-text">{{ text }}</span>
        <div class="notification-actions">
          <v-btn
            v-for="(button, index) in buttons"
            :key="index"
            :href="button.href"
            :target="button.target"
            :rel="button.rel"
            color="white"
            small
            class="notification-action"
            @click="buttonClicked(button)"
          >
            {{ button.text }}
          </v-btn>
        </div>
      </div>
      <v-btn
        fabs
        outlined
        small
        class="notification-close"
        @click="snackbar = false"
        icon
      >
        <v-icon small>
          mdi-close
        </v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({}),
  computed: {
    ...mapState('notification', ['color', 'text', 'timeout', 'buttons']),
    snackbar: {
      get () {
        return this.$store.state.notification.snackbar
      },
      set (val) {
        if (!val) {
          this.hideNotification()
        }
      }
    }
  },
  methods: {
    buttonClicked(button) {
      if (button && typeof button.click === 'function') {
        button.click()
      }
    },
    ...mapMutations('notification', ['hideNotification'])
  }
}
</script>

<style scoped>
.notification-content {
  align-items: stretch;
  display: flex;
  justify-content: center;
  min-height: 76px;
  padding: 8px 48px 10px;
  position: relative;
}

.notification-body {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 14px;
  justify-content: center;
  min-width: 0;
  text-align: center;
}

.notification-text {
  min-width: 0;
}

.notification-action {
  flex: 0 0 auto;
  white-space: nowrap;
}

.notification-action.v-btn {
  color: var(--v-info-base);
}

.notification-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  justify-content: center;
}

.notification-close {
  flex: 0 0 auto;
  position: absolute;
  right: 8px;
  top: 8px;
}
</style>
